import React, { useRef } from "react";
import { PostListModal } from "../Modals/PostListModal/PostListModal";
import { GroupInput } from "@shared/Types/GroupEntry.types";
import { publish } from "@infrastructure/Events/EventBus";
import { Box } from "@mui/system";
import { RefreshContentButton } from "../RefreshContentButton/RefreshContentButton";
import { REFRESH_LIST_EVENT } from "../DashboardComponents/PostList/PostsList";

export function PostListFacade({ groupData }: { groupData: GroupInput }) {
    const scrollToRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <Box ref={scrollToRef} />
            {scrollToRef && (
                <RefreshContentButton
                    onClick={() => {
                        publish({
                            name: REFRESH_LIST_EVENT,
                        });
                    }}
                    scrollToRef={scrollToRef}
                    isInsideModal={true}
                />
            )}
            {groupData?.id && <PostListModal groupData={groupData} />}
        </>
    );
}
